import { render, staticRenderFns } from "./CustomDropdown.vue?vue&type=template&id=13305b01&scoped=true&"
import script from "./CustomDropdown.vue?vue&type=script&lang=ts&"
export * from "./CustomDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13305b01",
  null
  
)

export default component.exports